import { AgGridReact } from 'ag-grid-react';
import { GridWrapper } from './styles';
import { ColDef, ColGroupDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { useMemo } from 'react';
import { Utility } from '@nkr/services/utility';
import { IColdIschemiaLagTime } from '@nkr/models/reports';

interface IProps {
    data: IColdIschemiaLagTime[],
    centerId: number,
    isCenterLogin?: boolean
}

const Grid = (props: IProps) => {
    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {

    };

    type MyColDef = ColDef | ColGroupDef;

    const columns: MyColDef[] = [
        {
            colId: 'Rank',
            headerName: 'R#',
            width: 55,
            sortable: false,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>R#</SortableHeaderComponent>,
            valueGetter: (params: ValueGetterParams) => params.node.rowIndex + 1,
        },
        {
            colId: 'swapNumber',
            field: 'swapNumber',
            headerName: 'swapNumber',
            width: 75,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>Swap #</SortableHeaderComponent>,
        },
        {
            groupId: 'donor',
            headerName: 'Donor',
            headerClass: 'group-header',
            children: [
                {
                    colId: 'donorCenter',
                    field: 'donorCenter',
                    headerName: 'Donor Center',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
                    cellRendererFramework: (params: ICellRendererParams) => {
                        let data = params.data as IColdIschemiaLagTime;


                        if (data.remoteDonorCenterId != null && data.remoteDonorCenterId > 0) {
                            if (data.donorCenterId == props.centerId) {
                                return (
                                    <><a href={`center/${props.centerId}/profile/edit`} target='_blank'>{data.donorCenter}</a> <span style={{ color: 'red' }}>(<a href={`/center/${data.remoteDonorCenterId}/reports/my-center/cold-ischemia-lag-time-detail`} target='_blank'>{data.remoteDonorCenter}</a>)</span></>
                                );
                            }

                            return (
                                <><a href={`/center/${data.donorCenterId}/reports/my-center/cold-ischemia-lag-time-detail`} target='_blank'>{data.donorCenter}</a> <span style={{ color: 'red' }}>(<a href={`/center/${data.remoteDonorCenterId}/reports/my-center/cold-ischemia-lag-time-detail`} target='_blank'>{data.remoteDonorCenter}</a>)</span></>
                            );
                        }


                        if (data.donorCenterId == props.centerId) {
                            return (
                                <a href={`center/${props.centerId}/profile/edit`} target='_blank'>{data.donorCenter}</a>
                            );
                        }


                        return (
                            <a href={`/center/${data.donorCenterId}/reports/my-center/cold-ischemia-lag-time-detail`} target='_blank'>{data.donorCenter}</a>
                        );

                    }

                },
                {
                    colId: 'donorAlias',
                    field: 'donorAlias',
                    headerName: 'Donor Alias',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
                },
            ]
        },
        {
            groupId: 'recipient',
            headerName: 'Recipient',
            headerClass: 'group-header',
            children: [

                {
                    colId: 'recipientCenter',
                    field: 'recipientCenter',
                    headerName: 'Recipient Center',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
                },
                {
                    colId: 'recipientAlias',
                    field: 'recipientAlias',
                    headerName: 'Recipient Alias',
                    width: 120,
                    headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Alias</SortableHeaderComponent>,
                },
            ]
        },
        {
            colId: 'crossClampReportTime',
            field: 'crossClampReportTime',
            headerName: 'Cross Clamp Report Time',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Cross Clamp<br />Report Time</SortableHeaderComponent>,
            comparator: Utility.dateComparator
        },
        {
            colId: 'crossClampTime',
            field: 'crossClampTime',
            headerName: 'Cross Clamp Time',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Cross Clamp Time</SortableHeaderComponent>,
            comparator: Utility.dateComparator
        },
        {
            colId: 'scheduledPickup',
            field: 'scheduledPickup',
            headerName: 'Offer',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Scheduled Pickup</SortableHeaderComponent>,
            comparator: Utility.dateComparator
        },
        {
            colId: 'citLagTimeMinutes',
            field: 'citLagTimeMinutes',
            headerName: 'On Time',
            width: 85,
            resizable: true,
            suppressSizeToFit: true,
            headerClass: 'header-row-span-2-left-right',
            headerComponentFramework: (props: IHeaderParams) => <SortableHeaderComponent {...props}>On Time</SortableHeaderComponent>,
            comparator: (valueA: number, valueB: number) => {
                const isParenA = valueA > 180 || valueA < 0;
                const isParenB = valueB > 180 || valueB < 0;
                if (isParenA !== isParenB) return isParenA ? 1 : -1;
                return Math.abs(valueA) - Math.abs(valueB);
            },
            cellRendererFramework: (params: ICellRendererParams) => {
                let data = params.data as IColdIschemiaLagTime;
                const minutes = data.citLagTimeMinutes;

                const formatMinutes = (mins: number): string => {
                    const absMins = Math.abs(mins);
                    if (absMins < 60) return `${absMins}m`;
                    const h = Math.floor(absMins / 60);
                    const m = absMins % 60;
                    return m > 0 ? `${h}h ${m}m` : `${h}h`;
                };

                const isOver = minutes > 180;
                const isNeg = minutes < 0;
                const color = isOver || isNeg ? '#c9372e' : 'inherit';
                const display = isOver || isNeg ? `(${formatMinutes(minutes)})` : formatMinutes(minutes);

                return (
                    <span style={{ color, fontWeight: 'normal' }}>
                        {display}
                    </span>
                );
            }
        },
        {
            colId: 'isCompliant',
            field: 'isCompliant',
            headerName: 'Compliant',
            width: 120,
            headerClass: 'header-row-span-2',
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Compliant</SortableHeaderComponent>,
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
            <AgGridReact
                defaultColDef={{
                    cellClass: 'list-cell',
                    headerClass: 'list-header',
                    sortable: true,
                    resizable: true
                }}
                columnDefs={columnDefs}
                rowData={rowData}
                enableCellTextSelection={true}
                enableRangeSelection={true}
                headerHeight={32}
                noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                onFirstDataRendered={onFirstDataRendered}
                onSortChanged={onSortChanged}
            />
        </GridWrapper>
    );
}

export default Grid;